<div class="detail-tabs">
  <div class="container-lg p-0">
    <div class="nav nav-tabs u-tabs">
      <div class="nav-item u-tabs__item u-tabs__item--special" *ngIf="brand?.detailPageConfig?.showPriceGrid">
        <a (click)="selectTab('solutions')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'solutions'">Soluzioni</a>
      </div>
      <div class="nav-item u-tabs__item" *ngIf="holidayDetails?.accomodation">
        <a (click)="selectTab('details')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'details'">Struttura</a>
      </div>
      <div class="nav-item u-tabs__item" *ngIf="holidayDetails?.accomodation && !hideMapForSpecificProduct">
        <a (click)="selectTab('map')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'map'">Mappa</a>
      </div>
      <div class="nav-item u-tabs__item" *ngIf="holidayDetails?.tour?.itinerary">
        <a (click)="selectTab('itinerary')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'itinerary'">Itinerario</a>
      </div>
      <div class="nav-item u-tabs__item" *ngIf="holidayDetails?.activities.length > 0">
        <a (click)="selectTab('activities')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'activities'">Attività</a>
      </div>
      <div class="nav-item u-tabs__item" *ngIf="holidayDetails?.facilities.length > 0">
        <a (click)="selectTab('facilities')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'facilities'">Facilities</a>
      </div>
      <div class="nav-item u-tabs__item" *ngIf="holidayDetails?.accessories.length > 0">
        <a (click)="selectTab('terms')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'terms'">Termini</a>
      </div>
      <div class="nav-item u-tabs__item" *ngIf="holidayDetails?.hasSolutionsWithFlight && !brand?.detailPageConfig?.showPriceGrid">
        <a (click)="selectTab('flights')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'flights'">Voli</a>
      </div>
    </div>
  </div>
</div>
